import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentVotes: {
    categoria1: 0,
    categoria2: 0,
    categoria3: 0,
    categoria4: 0,
    categoria5: 0,
  },
  hasVoted: false,
  loading: false,
  error: null,
  results: null,
};

const votingSlice = createSlice({
  name: 'voting',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setCurrentVotes: (state, action) => {
      state.currentVotes = action.payload;
    },
    updateVote: (state, action) => {
      const { category, score } = action.payload;
      state.currentVotes[category] = score;
    },
    setHasVoted: (state, action) => {
      state.hasVoted = action.payload;
    },
    setResults: (state, action) => {
      state.results = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    resetVotes: (state) => {
      state.currentVotes = {
        categoria1: 0,
        categoria2: 0,
        categoria3: 0,
        categoria4: 0,
        categoria5: 0,
      };
      state.hasVoted = false;
      state.error = null;
    },
  },
});

export const {
  setLoading,
  setCurrentVotes,
  updateVote,
  setHasVoted,
  setResults,
  setError,
  resetVotes,
} = votingSlice.actions;

export default votingSlice.reducer;